import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";

export const ConfirmCheckbox = ({
  id,
  checked,
  onChange,
  showSuccess,
  children,
  disabled,
}: {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  showSuccess?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}) => (
  <GenericTooltip
    content="Uncheck the 'Complete' checkbox at the bottom of the screen to update"
    showTooltip={!!disabled}
    noInfoCircle
    placement="top-start"
  >
    <div
      className={clsx(
        "p-6 rounded-lg border justify-between items-center gap-4 flex flex-row",
        {
          "bg-alien-2": checked && showSuccess,
          "bg-cosmic-5": !checked || !showSuccess,
        },
      )}
    >
      <div className="justify-between items-center inline-flex w-full">
        <div className="justify-center items-center gap-2 inline-flex">
          <label
            htmlFor={id}
            className={clsx(
              "mb-0 pb-0 text-lg font-normal leading-normal flex items-center",
            )}
          >
            <input
              disabled={disabled}
              id={id}
              type="checkbox"
              value=""
              className={clsx("pb-0 mb-0 mr-2 ", {
                "checked:before:border-alien+0 checked:before:bg-alien+0":
                  checked && showSuccess,
                " check": !disabled,
                "cursor-not-allowed": !!disabled,
              })}
              checked={checked}
              onChange={(e) => {
                onChange(e.target.checked);
              }}
            />
            <span
              className={clsx({
                "cursor-pointer": !disabled,
                "cursor-not-allowed": !!disabled,
              })}
            >
              {children}
            </span>
          </label>
        </div>
      </div>
    </div>
  </GenericTooltip>
);
